import { ToppingsCategory } from '../store/toppingsCategory/api/interface';

export const fillToppingsCategoryState = (state: ToppingsCategory) => {
  const reqBody = {
    id: state.id ?? '',
    labelEn: state?.labelEn ?? '',
    labelAr: state?.labelAr ?? '',
    imgUrl: state?.imgUrl ?? '',
    position: state?.position ?? '',
    activeState: state?.activeState,
    // items: state?.topping_category_items?.map((item) => {

    //   const shapeItems: ShapeItems[] = [];
    //   item?.shapeImages?.map((element) => {
    //     const itemBody = {
    //       shapeId: element?.shapeId ?? '',
    //       top: element?.top,
    //       front: element?.front,

    //     };
    //     shapeItems.push(itemBody);
    //   });

    //   return {
    //     id: item?.id ?? '',
    //     code: item?.code ?? '',
    //     labelEn: item?.labelEn ?? '',
    //     labelAr: item?.labelAr ?? '',
    //     descriptionEn: item?.descriptionEn ?? '',
    //     descriptionAr: item?.descriptionAr ?? '',
    //     price: item?.price ?? '',
    //     discountedPrice: item?.discountedPrice ?? '',
    //     effortScore: item?.effortScore ?? '',
    //     previewUrl: item?.previewUrl ?? '',
    //     position: item?.position ?? '',
    //     activeState: item?.activeState,
    //     hasColor: item?.hasColor,
    //     isNew: item?.isNew,
    //     shapeItems: shapeItems
    //   };
    // }),
  };

  return reqBody;
};
